import React, {
    AnchorHTMLAttributes,
    PropsWithChildren,
    ReactElement,
} from 'react';

import { Icon } from '@pb/shared/ui/atoms/icon';
import { TLinkProperties } from './link.types';
import { StyledLink, StyledWrapper } from './link.styled';

/**
 * Links can be shown as just text, text and an icon or just an icon.
 */
export function Link({
    to,
    icon,
    target = '_self',
    className,
    onClick,
    children,
    linkType = 'default',
    ariaLabel,
    inverted = false,
}: PropsWithChildren<TLinkProperties>): ReactElement {
    const iconComponent =
        icon && linkType === 'default' ? (
            <Icon size={22} type={icon} color={inverted ? 'white' : 'purple'} />
        ) : null;

    const isLink =
        to &&
        (to.startsWith('http') ||
            to.startsWith('tel:') ||
            to.startsWith('mailto:'));

    const elementSpecificProperties: AnchorHTMLAttributes<HTMLAnchorElement> =
        isLink
            ? {
                  href: to,
                  target,
                  rel: 'noreferrer noopener',
              }
            : {
                  onClick,
              };

    return (
        <StyledWrapper className={className}>
            <StyledLink
                as={isLink ? 'a' : 'button'}
                linkType={linkType}
                hasIcon={Boolean(icon)}
                inverted={inverted}
                aria-label={ariaLabel}
                {...elementSpecificProperties}
            >
                {iconComponent}
                {children}
            </StyledLink>
        </StyledWrapper>
    );
}
